import { select } from "async";
import React from "react";

/**
 * props:
 *  - String selectId
 *  - Function removeFilter
 *  - Function addFilter
 *  - Array<LookupTable> currentFilters
 *  - Array<LookupTable> unusedFilters
 *  - Array<LookupTable> years (filter syllabi by: year=<year lookup's value>)
 *  - Array<LookupTable> semesters (filter syllabi by: semester=<semester lookup's value>)
 **/
const Filters = (props) => {
  const {
    addFilter,
    currentFilters,
    selectId,
    removeFilter,
    setSigularFilter,
    semesters,
    unusedFilters,
    years,
  } = props;
  /** SUBJECT FILTERS LOGIC **/
  const addFilterEnabled = unusedFilters.length > 0;
  const opts = unusedFilters.map((f, i) => {
    return (
      <option id={"subjOpt-" + f.id} key={"subjOpt" + f.id} value={i}>
        {f.name}
      </option>
    );
  });
  const defaultOpt = (
    <option id="subjOpt-d" key="subjOpt-d" value="-1">
      Select Subject
    </option>
  );

  const selections = currentFilters.map((f, i) => {
    return (
      <span
        key={"curSubj-" + i}
        className="mt-2 ml-1 badge badge-info col-1 d-flex justify-content-around"
      >
        <button
          type="button"
          className="close"
          onClick={(e) =>
            removeFilter({ rmIx: i, paramArr: "subject_lookup_id" }, e)
          }
        >
          <span>&times;</span>
        </button>
        <span className="p-2">{f.name}</span>
      </span>
    );
  });

  /** YEAR FILTER OPTIONS **/
  const yearOpts = years.map((y) => (
    <option key={`yr-${y.name}`} value={y.value || 0}>
      {y.name}
    </option>
  ));
  const setYearFilter = (e) => setSigularFilter("year", e);

  /** SEMESTER FILTER OPTIONS **/
  const semesterOpts = semesters.map((s) => (
    <option key={`sem-${s.name}`} value={s.value || 0}>
      {s.name}
    </option>
  ));
  const setSemesterFilter = (e) => setSigularFilter("semester", e);

  return (
    <div className="mt-2">
      <select id={selectId} className="btn btn-secondary">
        {defaultOpt}
        {opts}
      </select>
      <div
        className="btn-group pl-1 pr-1"
        role="group"
        aria-label="Button group with nested dropdowns"
      >
        <select
          id="years-select"
          className="btn btn-secondary"
          onChange={setYearFilter}
        >
          {yearOpts}
        </select>
        <select
          id="semesters-select"
          className="btn btn-secondary"
          onChange={setSemesterFilter}
        >
          {semesterOpts}
        </select>
      </div>
      <button
        className="btn btn-secondary ml-1"
        onClick={(e) =>
          addFilter(
            {
              selectElem: selectId,
              paramArr: "subject_lookup_id",
              enabled: addFilterEnabled,
            },
            e
          )
        }
      >
        Show
      </button>
      <div className="row ml-1 d-flex justify-content-left">{selections}</div>
    </div>
  );
};

export default Filters;
